module.exports = __webpack_public_path__ + "img/tmf_banner.2039a863.jpg";